import type { CategoryLevel } from "../enums/CategoryLevel"

export class AllCategoriesMiniEntity {
    id?: number 
    iconUrl?: string | null 
    parentId?: number | null 
    name?: string | null 
    level?: CategoryLevel 
    branchId?: number 
    branchName?: string | null 
    enabled?: boolean 
    isSensitive?: boolean 
    totalItems?: number 
    createdAt?: string 
}